import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _class;
import React from "react";
import intl from "../../utils/intl";
import { BlockContainer } from "./index.style";
import SectionTitle from "../_components/SectionTitle";
import ConfigItem from "../_components/ConfigItem";
import withFormOperate from "../_components/withFormOperate";
import { getMemoizedAssets } from "./util";
var AnchorConfig = withFormOperate(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(AnchorConfig, _React$Component);
  var _super = _createSuper(AnchorConfig);
  function AnchorConfig() {
    var _this;
    _classCallCheck(this, AnchorConfig);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.getBaseAnchor = getMemoizedAssets(_this.props.styleCounts.anchor, "anchor/base");
    _this.getTreeAnchor = getMemoizedAssets(_this.props.styleCounts.stepsGroup, "anchor/tree");
    return _this;
  }
  _createClass(AnchorConfig, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        handleChange = _this$props.handleChange,
        schema = _this$props.schema;
      return this.props.styleCounts.anchor ? /*#__PURE__*/React.createElement(BlockContainer, {
        id: "anchor-config"
      }, /*#__PURE__*/React.createElement(SectionTitle, {
        title: "\u951A\u70B9",
        titleTail: "Anchor"
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "anchor" // cols={2}
        ,

        title: intl.get("hzero.hzeroTheme.components.baseAnchor").d("基础锚点"),
        items: this.getBaseAnchor(schema),
        defaultSelected: value,
        onChange: handleChange("anchor")
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "anchor" // cols={2}
        ,

        title: intl.get("hzero.hzeroTheme.components.treeAnchor").d("树状结构锚点"),
        items: this.getTreeAnchor(schema),
        defaultSelected: value,
        onChange: handleChange("anchor")
      })) : null;
    }
  }]);
  return AnchorConfig;
}(React.Component)) || _class;
export { AnchorConfig as default };